import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as terapiaPlanService from "../../services/terapiaPlanService";
import * as terapiaService from "../../services/terapiaService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import TherapyPlan from '../../components/TherapyPlan'
import TherapyPlanArea from '../../components/TherapyPlanArea'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsTherapyPlan } from '../../redux/therapyPlanSlice';
import { setEntity as setTherapyPlanArea, activeValidations as activeTherapyPlanArea } from '../../redux/therapyPlanAreaSlice';

const Edit = (props) => {
   const therapyPlan = useSelector((state) => state.therapyPlan.entity);
   const therapyPlanArea = useSelector((state) => state.therapyPlanArea.entity);
   const therapyPlanValidation = useSelector((state) => state.therapyPlan.validationMessage);
   const therapyPlanAreaValidation = useSelector((state) => state.therapyPlanArea.validationMessage);

   const defaultTherapyPlanArea = useSelector((state) => state.therapyPlanArea.defaultEntity)
  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const dispatch = useDispatch();
  const params = useParams();
  const { isReadOnly, setIsReadOnly } = useMantenimiento("terapiaPlan");
  const postEntity = async () => {
    var dataPost = {
      ...therapyPlan
      , terapiaPlanArea: therapyPlanArea
    }

    var ValidationMessages = therapyPlanValidation.concat(therapyPlanAreaValidation)

    if (ValidationMessages.length > 0) {
      dispatch(activeValidationsTherapyPlan());
      dispatch(activeTherapyPlanArea());

      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      setOpenMessage(true);
    }
    else {
      await terapiaPlanService.addUpdateTerapiaPlanWithDetails(dataPost)
        .then(response => {
          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          if (therapyPlan.id > 0){
            terapiaService.getsTerapiaPlanAreaView(therapyPlan.id)
            .then(data => {
              if (data === null || data.length === 0)
                dispatch(setTherapyPlanArea(defaultTherapyPlanArea));
              else
                dispatch(setTherapyPlanArea(data));
            })
            .catch((err) => {
              console.log("Err: ", err);
            });
          }
        })
        .catch(error => {
          setPropsMessage({ severity: "error", message: "Hubo un error" })
          setOpenMessage(true);
        });
    }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nuevo" : "Editar") + " Plan de Terapia"}
        backTo={"/therapy"}
        onSave={postEntity}
        disabled={isReadOnly}
      >
        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card >
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapyPlan isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <TherapyPlanArea isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit
